"use client";

import Card from "@mui/material/Card";
import MuiTable from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { twMerge } from "tailwind-merge";

import {
  AddTableCell,
  CustomTableCell,
  InfoTableCell,
  LiTableCell,
  LinkTableCell,
  TextTableCell,
} from "./TableCell";
import { TableProps, TableRowProps } from "./TableProps";

export const Table = ({
  data,
  showCard = true,
  emptyView,
  rowHeight = 52,
  isFirstColSticky = false,
  ...props
}: TableProps) => (
  <WrapperCard showCard={showCard}>
    <TableContainer>
      <MuiTable {...props}>
        <TableBody>
          {data.map((row, index) =>
            generateTableRow(row, index, rowHeight, isFirstColSticky)
          )}
          {data.length === 1 && (
            <TableRow>
              <TableCell colSpan={data[0].cells.length}>
                {emptyView ? (
                  emptyView
                ) : (
                  <div className="flex h-[150px] w-full items-center justify-center">
                    No data
                  </div>
                )}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </MuiTable>
    </TableContainer>
  </WrapperCard>
);

const WrapperCard = ({
  showCard,
  children,
}: {
  showCard: boolean;
  children: JSX.Element;
}) =>
  showCard ? (
    <Card variant="outlined" className="rounded-lg">
      {children}
    </Card>
  ) : (
    children
  );

const generateTableRow = (
  row: TableRowProps,
  index: number,
  rowHeight: number,
  isFirstColSticky: boolean
) => (
  <TableRow
    key={index}
    sx={{
      "--bg-color": row.rowColor,
      height: rowHeight,
      backgroundColor: row.rowColor,
      borderBottom: row.dividerStyle || "solid 1px #F3F4F6",
      "& td": { borderBottom: "none" },
    }}
  >
    {row.cells.map((cell, index) => {
      if (isFirstColSticky && index === 0)
        cell.className = twMerge(
          cell?.className,
          "sticky left-0 bg-[var(--bg-color)]"
        );

      switch (cell.type) {
        case "text":
          return <TextTableCell {...cell} key={index} />;
        case "link":
          return <LinkTableCell {...cell} key={index} />;
        case "add":
          return <AddTableCell {...cell} key={index} />;
        case "li":
          return <LiTableCell {...cell} key={index} />;
        case "info":
          return <InfoTableCell {...cell} key={index} />;
        case "custom":
          return <CustomTableCell {...cell} key={index} />;
        default:
          return <TextTableCell {...cell} key={index} />;
      }
    })}
  </TableRow>
);
